import React from 'react';
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import customStyles from "../../../../../assets/styles/customStyles";
import { Button, TextField, Box, Typography } from "@mui/material";
import clsx from "clsx";
import { Col, Row, Space } from "antd";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import { NavLink } from "react-router-dom";
import { idNamingConversion } from '../../../../../helpers/utilities';

export const UnitForm = (props) => {
    const { visible, handleSubmit, unitId,
        handleClose, handleAddMore, form,
        productForm, unitMesurementdetails, onEdit,
        customObject, changeHandler, error, title, view, formRelation
    } = props;


    const classes = customStyles();
    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            width={'495px'}
            title={`${title === 'Add' ? `${title} New` : title} Unit Conversion`}
            className={clsx(classes.closeBackGround, classes.width100P)}
            component={
                <Box
                    className={clsx(classes.customForm, classes.removeUnderline)}
                    component="form"
                    autoComplete='off'
                    onSubmit={(e) => handleSubmit(e)}>
                    <div className={classes.customFormFlex}>
                        <Row gutter={20}>
                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Product</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{productForm?.productName || '---'}</Typography>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24} className={classes.positionRelative}>
                                <div className={classes.unitFor}>For 1</div>
                                <div className={classes.unitForText}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx('MuiInputLabel-shrink', classes.margin20t, classes.textFieldLableColorCustom, classes.fonSize13)}>From Unit</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{formRelation.unit}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["From Unit ", <span key={'From Unit'} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={unitMesurementdetails}
                                                id={idNamingConversion('From Unit', 'productUnit', 'DropDown')}
                                                parentValue={customObject(unitMesurementdetails, form.unitId)}
                                                onChange={(data) => changeHandler(data.id, 'unitId')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.unitId}
                                            />
                                    }
                                </div>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Conversion  Factor</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.conversionFactor}</Typography>
                                        </> :
                                        <TextField autoComplete='one-time-code'
                                            label='Conversion  Factor'
                                            variant={'standard'}
                                            type={'text'}
                                            className={clsx(classes.margin20t)}
                                            error={error.conversionFactor ? true : false}
                                            helperText={error.conversionFactor}
                                            name={"conversionFactor"}
                                            fullWidth
                                            step="any"
                                            value={form.conversionFactor}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            id={idNamingConversion('Conversion Factor', 'productUnit', 'TextField')}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>To Unit</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{formRelation.toUnit}</Typography>
                                        </> :
                                        <AutoCompleteComponent
                                            name={["To Unit ", <span key={'To Unit'} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'name', 'name': 'Unit' },
                                            { 'key': 'description', 'name': 'Description' }]}
                                            details={unitMesurementdetails}
                                            parentValue={customObject(unitMesurementdetails, form.toUnitId)}
                                            onChange={(data) => changeHandler(data.id, 'toUnitId')}
                                            position={"bottom"}
                                            id={idNamingConversion('To Unit', 'productUnit', 'DropDown')}
                                            customClasses={classes.margin20t}
                                            parentError={error.toUnitId}
                                        />
                                }
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Addition Factor</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.additionalFactor}</Typography>
                                        </> :
                                        <TextField autoComplete='one-time-code'
                                            label='Addition Factor'
                                            variant={'standard'}
                                            type={'text'}
                                            step="any"
                                            className={clsx(classes.margin20t)}
                                            error={error.additionalFactor ? true : false}
                                            helperText={error.additionalFactor}
                                            name={"additionalFactor"}
                                            fullWidth
                                            value={form.additionalFactor}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            id={idNamingConversion('Addition Factor', 'productUnit', 'TextField')}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                            </Col>
                            {
                                form.unitId && form.toUnitId && form.conversionFactor &&
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Typography variant={'subtitle1'} className={clsx(classes.addressSmall, classes.bold, classes.margin20t, classes.fonSize13)}>Note:</Typography>
                                    <div className={clsx(classes.unitNote, classes.bold)}>
                                        {`1 ${customObject(unitMesurementdetails, parseInt(form.unitId))?.name} = ${(parseFloat(form.conversionFactor) + parseFloat(form.additionalFactor))} ${customObject(unitMesurementdetails, parseInt(form.toUnitId))?.name}`}
                                    </div>
                                </Col>
                            }
                            {
                                error?.common && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}><CustomAlert error={error?.common} customClass={clsx(classes.uploadError, classes.margin10t)} /></Col>
                            }
                        </Row>
                    </div>
                    <div className={clsx(classes.btnParent)}>
                        {
                            view ? <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => { onEdit(form); }}>Edit</NavLink> :
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn)}>
                                        {
                                            unitId ? 'Update & Close' : 'Save & Close'
                                        }
                                    </Button>
                                    {
                                        !unitId && <Button
                                            key="add"
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.AddMoreBtn)}
                                            onClick={(e) => handleAddMore(e, 'unit')}>
                                            Add More
                                        </Button>
                                    }
                                </Space>
                        }
                    </div>
                </Box>
            }
        />
    )
}
